import React, { useState } from "react";
import { Edit } from "lucide-react";
import "./SeriesMaster.css";

const initialFormState = {
  memberPrefix: "",
  memberSeries: "",
  memberBranchCode: "YES",

  employeePrefix: "",
  employeeSeries: "",
  employeeBranchCode: "YES",

  applicationSeries: "",
  applicationBranchCode: "YES",

  branchPrefix: "",
  branchSeries: ""
};

const SeriesMaster = () => {
  const [editing, setEditing] = useState(true); // first time add mode
  const [isSaved, setIsSaved] = useState(false); // track first save

  const [formData, setFormData] = useState(initialFormState);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleEdit = () => {
    setEditing(true);
  };

  const handleSave = (e) => {
    e.preventDefault();

    console.log("Saved Data:", formData);

    setEditing(false);
    setIsSaved(true);
  };

  return (
    <div className="series-container">
      
      <div className="series-header">
        <span>SERIES MASTER</span>

        {isSaved && !editing && (
          <button className="edit-btn" onClick={handleEdit}>
            <Edit size={16} /> Edit
          </button>
        )}
      </div>

      <form className="series-form" onSubmit={handleSave}>
        
        {/* MEMBER SERIES */}
        <div className="form-card">
          <h3>MEMBER SERIES</h3>

          <label>Member Prefix</label>
          <input
            name="memberPrefix"
            value={formData.memberPrefix}
            disabled={!editing}
            onChange={handleChange}
          />

          <label>Member Series</label>
          <input
            name="memberSeries"
            value={formData.memberSeries}
            disabled={!editing}
            onChange={handleChange}
          />

          <label>Branch Code Inclusion</label>
          <select
            name="memberBranchCode"
            value={formData.memberBranchCode}
            disabled={!editing}
            onChange={handleChange}
          >
            <option>YES</option>
            <option>NO</option>
          </select>
        </div>

        {/* EMPLOYEE SERIES */}
        <div className="form-card">
          <h3>EMPLOYEE / AGENT SERIES</h3>

          <label>Employee Prefix</label>
          <input
            name="employeePrefix"
            value={formData.employeePrefix}
            disabled={!editing}
            onChange={handleChange}
          />

          <label>Employee Series</label>
          <input
            name="employeeSeries"
            value={formData.employeeSeries}
            disabled={!editing}
            onChange={handleChange}
          />

          <label>Branch Code Inclusion</label>
          <select
            name="employeeBranchCode"
            value={formData.employeeBranchCode}
            disabled={!editing}
            onChange={handleChange}
          >
            <option>YES</option>
            <option>NO</option>
          </select>
        </div>

        {/* APPLICATION SERIES */}
        <div className="form-card">
          <h3>APPLICATION SERIES</h3>

          <label>Application Series</label>
          <input
            name="applicationSeries"
            value={formData.applicationSeries}
            disabled={!editing}
            onChange={handleChange}
          />

          <label>Branch Code Inclusion</label>
          <select
            name="applicationBranchCode"
            value={formData.applicationBranchCode}
            disabled={!editing}
            onChange={handleChange}
          >
            <option>YES</option>
            <option>NO</option>
          </select>
        </div>

        {/* BRANCH SERIES */}
        <div className="form-card">
          <h3>BRANCH SERIES</h3>

          <label>Branch Prefix</label>
          <input
            name="branchPrefix"
            value={formData.branchPrefix}
            disabled={!editing}
            onChange={handleChange}
          />

          <label>Branch Series</label>
          <input
            name="branchSeries"
            value={formData.branchSeries}
            disabled={!editing}
            onChange={handleChange}
          />
        </div>

        {editing && (
          <button className="save-btn">
            {isSaved ? "Update" : "Save"}
          </button>
        )}
      </form>
    </div>
  );
};

export default SeriesMaster;